import React from 'react';
import {useLocation} from 'react-router-dom';
import logo from '../../assets/cropped-logo_LYFP-2.png';


function Banner() {
    const {pathname} = useLocation();
    const linkProps = (href) => {
        const isActive = (pathname.replace(/\/+$/, '') || '/') === href;
        return {
            className: isActive ? 'nav-link active' : 'nav-link',
            'aria-current': isActive ? 'page' : undefined,
            href,
        };
    };

    return (
        <div className="sticky-top">
            <nav className="navbar  navbar-expand-lg bg-body">
                <div className="container-fluid">
                    <a className="navbar-brand ps-md-5 " href="/">
                        <img src={logo} alt="Love Your Feet Podiatry logo" width="150" height="40"/>
                    </a>
                    {/* Navbar Toggler for smaller screens */}
                    <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
                        <span className="navbar-toggler-icon"></span>
                    </button>
                    <div className="collapse navbar-collapse text-end" id="navbarNav">
                        <ul className="navbar-nav ms-auto pe-3">
                            <li className="nav-item">
                                <a {...linkProps('/')}>Home</a>
                            </li>
                            <li className="nav-item">
                                <a {...linkProps('/information')}>
                                    Information
                                    <span className="badge rounded-pill bg-warning text-white ms-1" style={{fontSize: '0.6rem', verticalAlign: 'middle'}}>NEW</span>
                                </a>
                            </li>
                            <li className="nav-item">
                                <a {...linkProps('/appointment')}>Appointment</a>
                            </li>
                            <li className="nav-item">
                                <a {...linkProps('/contactus')}>Contact Us</a>
                            </li>
                        </ul>
                    </div>
                </div>
            </nav>
        </div>
    );
}

export default Banner;
